module.exports = __webpack_public_path__ + "img/colisao.f57cd966.png";